import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class SiteMedia extends AManagerApi {
    protected _url: string = '/owner/site/media';
}
